import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../../../theme';

export const useShipmentTemplateFormContentStyles = createStyles(
  ({ token }) => ({
    shipmentTemplateFormName: {
      fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
      fontWeight: 300,
      padding: `${ThemeSpaces.SPACE_NORM0_5}px 0 ${token.paddingMD}px 0`,
    },
  })
);
